<div class="page-container" style="min-height:188.38330078125px">
  <!--Page content -->
  <div (resize)="onResize($event)" class="page-content text-center" *ngIf="pdfSrc.url">
    <pdf-viewer
                [src]="pdfSrc.url"
                [(page)]="page"
                [rotation]="rotation"
                [show-all]="showAll"
                (after-load-complete)="afterLoadComplete($event)"
                [zoom]="zoom"
                [render-text]="renderText"
                (error)="onError($event)"
                style="display: block; width: 100%; height: 100%; position: absolute;">
    </pdf-viewer>
  </div>
</div>

<!--Modal Info-->
<div *ngIf="modalInfoVisibility" id="jobDetailsInfoModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary clearfix">
        <div>
          <button class="btn btn-link pull-right" type="button" data-dismiss="modal">x</button>
        </div>
        <div class="row col-md-11 col-sm-10 col-xs-10">
          <div class="col-md-11 col-sm-11 col-xs-10">
            <h3 class="modal-title">{{theJob?.name}}</h3>
          </div>
          <div class="col-md-1 col-sm-1 col-xs-2">
            <!--<div *ngIf="theJob?.status == 'NONE'">-->
            <!--<h1><span class="label label-default" translate>NONE</span></h1>-->
            <!--</div>-->
            <div *ngIf="theJob?.status == 'DRAFT'">
              <h3><span class="label label-default" translate>DRAFT</span></h3>
            </div>
            <div *ngIf="theJob?.status == 'IN_PROGRESS'">
              <h3><span class="label label-warning" translate>IN_PROGRESS</span></h3>
            </div>
            <div *ngIf="theJob?.status == 'REJECTED'">
              <h3><span class="label label-danger" translate>REJECTED</span></h3>
            </div>
            <div *ngIf="theJob?.status == 'COMPLETED'">
              <h3><span class="label label-success" translate>COMPLETED</span></h3>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <ul class="list-inline">
              <li [hidden]="theJob != null">
                <h4>
                  <img src="https://cdn3.iconfinder.com/data/icons/real-estate-volume-3-1/48/135-32.png" alt="Job Owner" style="vertical-align:middle" >
                  <span>{{theJob?.user.name}}</span>
                </h4>
              </li>
              <li *ngIf="theJob?.shared"><strong>{{'Requested:' | translate}} </strong>{{theJob.shared | date: 'dd/MM/yyyy'}}</li>
            </ul>
          </div>
          <br>

          <h4 translate>Recipients</h4>

          <div *ngFor="let container of containers; let i = index">
            <div class="panel panel-flat border-grey-300 border-*-info inner-shadow">
              <div class="panel-body">
                <div class="row position">
                  <div class="col-md-1 col-sm-1 col-xs-1" style="text-align: center">
                    <strong>{{i+1}}</strong>
                  </div>
                  <div class="col-md-11 col-sm-11 col-xs-11 border-left">
                    <ul class="list-group no-border">
                      <li *ngFor="let recipient of container.widgets; let x = index">
                        <div class="row">
                          <div class="col-md-10 col-sm-10 col-xs-9">
                            <h5 class="panel-title">{{recipient?.name}}</h5>
                          </div>
                          <div class="col-md-2 col-sm-2 col-xs-3 text-center">
                            <div *ngIf="recipient?.status == 'INLINE'">
                              <h5> <span class="label label-default" translate>IN-LINE</span> </h5>
                            </div>
                            <div *ngIf="recipient?.status == 'WAITING'">
                              <h5> <span class="label label-warning" translate>WAITING</span> </h5>
                            </div>
                            <div *ngIf="recipient?.status == 'SIGNED'">
                              <h5> <span class="label label-success" translate>SIGNED</span> </h5>
                            </div>
                            <div *ngIf="recipient?.status == 'DECLINED'">
                              <h5> <span class="label label-danger" translate>DECLINED</span> </h5>
                            </div>
                            <div *ngIf="recipient?.status == 'REVOKED'">
                              <h5> <span class="label label-warning" translate>REVOKED</span> </h5>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-10 col-sm-10 col-xs-9">
                            <ul class="list-inline">
                              <li *ngIf="recipient?.email" class="no-border"><i class="icon-mail5"></i>{{recipient?.email}}</li>
                              <li *ngIf="recipient?.citizenId" class="no-border"><i class="icon-user"></i>{{recipient?.citizenId}}</li>
                            </ul>
                          </div>
                          <div class="col-md-2 col-sm-2 col-xs-3 text-center">
                            <p>{{recipient?.updated | date: 'dd/MM/yyyy'}}</p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h4 translate>Details</h4>

          <div class="panel panel-flat border-grey-300 border-*-info inner-shadow">
            <div class="panel-body">
              <table class="table table-md table-sm table-xs table-borderless">
                <tbody>
                <tr>
                  <th class="col-md-2 col-sm-2 col-xs-3"><strong translate>Name</strong></th>
                  <td class="col-md-10 col-sm-10 col-xs-9">{{theJob?.documents[0].name}}</td>
                </tr>
                <tr>
                  <th class="col-md-2 col-sm-2"><strong translate>Page</strong></th>
                  <td class="col-md-10 col-sm-10">{{theJob?.documents[0]?.page}}</td>
                </tr>
                <tr>
                  <th class="col-md-2 col-sm-2 col-xs-3"><strong translate>Size</strong></th>
                  <td class="col-md-10 col-sm-10 col-xs-9">{{theJob?.documents[0]?.size}} KB</td>
                </tr>
                <tr>
                  <th class="col-md-2 col-sm-2 col-xs-3"><strong translate>Uploaded</strong></th>
                  <td class="col-md-10 col-sm-10 col-xs-9">{{theJob?.documents[0]?.created | date: 'dd/MM/yyyy'}}</td>
                </tr>
                <tr>
                  <th class="col-md-2 col-sm-2 col-xs-3"><strong translate>Last Update</strong></th>
                  <td class="col-md-10 col-sm-10 col-xs-9">{{theJob?.updated | date: 'dd/MM/yyyy'}} </td>
                </tr>
                <tr>
                  <th class="col-md-2 col-sm-2 col-xs-3"><strong translate>Location</strong></th>
                  <td class="col-md-10 col-sm-10 col-xs-9">{{translate.instant(theJob?.location)}} </td>
                </tr>
                <tr>
                  <th class="col-md-2 col-sm-2 col-xs-3"><strong translate>Labels</strong></th>
                  <td class="col-md-10 col-sm-10 col-xs-9">
                    <div class="form-group">
                      <div class="tags" *ngFor="let tag of theJob?.tags;">
                        <span class="tag label label-primary">{{tag}}</span>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Close</button>
      </div>
    </div>
  </div>
</div>
<!--Modal Info-->
